import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { GlobalInvitation, RoleType } from '@promo/shared';
import * as api from '@/lib/api';

// Query key
const globalInvitationsKey = ['globalInvitations'] as const;

// Fetch global invitations for current user
export function useGlobalInvitations(options?: { enabled?: boolean }) {
  return useQuery<GlobalInvitation[]>({
    queryKey: globalInvitationsKey,
    queryFn: () => api.get<GlobalInvitation[]>('/global-invitations'),
    enabled: options?.enabled ?? true,
  });
}

// Send a new global invitation
export function useCreateGlobalInvitation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ inviteeEmail, roleRequested }: { inviteeEmail: string; roleRequested: RoleType }) => {
      return api.post<GlobalInvitation>('/global-invitations', {
        inviteeEmail,
        roleRequested,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: globalInvitationsKey });
    },
  });
} 